import { Injectable, OnDestroy } from "@angular/core";
import { LoggerService } from "@wdpr/ra-angular-logger";
import { Subject } from "rxjs";
import { OneIDConfigService } from "./one-id.config.service";
import { IOneIDConfig } from "../interfaces/iOneIDConfig";
import { ConfigService } from '@core/config.service';

      declare global {
        interface Window {
          PEP: any;
        }
      }
      
      @Injectable({
        providedIn: "root",
      })
export class OneIDService implements OnDestroy {
      oneIdConfig: IOneIDConfig;
      oneIdConfigDcl: any;
      envConfig: any;
      initOneId: any;
      isLogged: boolean | undefined;
      promotionID: string;
      marketingCodes: string[];
      newsLetterOpt: {} | undefined;
      public isLoggedInSubject = new Subject<any>();
      public isSubscribedNewsletter = new Subject<any>();
    
      constructor(
          private _config: OneIDConfigService,
          private _logger: LoggerService,
          private configService: ConfigService,
        ) {
          this.oneIdConfig = this._config.configuration;
          this.oneIdConfigDcl = this.oneIdConfig.brands.dcl.oneId;
          this.promotionID = this.oneIdConfigDcl.promotionId;
          this.marketingCodes = this.oneIdConfigDcl.marketingCodes;
          this.envConfig = this._config.getEnvFromUrl();
          const toggles = this.configService.getValue('toggles');
          if (toggles.leadgen_toggle) {
            window.PEP.PROFILE_AUTH.init({
              oneIdScriptSrc: `https://${this.envConfig.oneIdLibraryUrlPrefix}.registerdisney.go.com/v2/outer/DisneyID.js`,
              loadScript: true,
              clientId: `${this.oneIdConfigDcl.clientId}-${this.envConfig.oneIdEnv}`,
              langPref: "en-US",
              responderPage: `${window.location.href.match(/(.*)\//g)}authentication/responder.html`,
              cssOverride: `https://${this.envConfig.oneIdProfileLibraryUrlPrefix}.parksmedia.wdprapps.disney.com/media/lightbox/dcl/styles/branded-web.css`,
            }).then(() => {
              this.initOneIDStatus();
            });
          }
      }
    
      public async launchOneIDModal(): Promise<void> {
        window.PEP.PROFILE_AUTH.did.getLoggedInStatus()
        .then((status: any) => {
            if (!status) {
                return window.PEP.PROFILE_AUTH.launchLogin()
                      .fail((err: any) => {
                        this._logger.error('login modal err: ', err);
                      });
            } 

            return window.PEP.PROFILE_AUTH.did.launchNewsletters(this.promotionID).then(() => {
              window.PEP.PROFILE_AUTH.did.getGuestNewsletters().then((data: any) => {
                window.PEP.PROFILE_AUTH.on('close', () => {
                  this.isSubscribedNewsletter.next(data);
                });
              });
            });
        });
      }
    
      public launchNewsletterModal(): Promise<void> {
          return window.PEP.PROFILE_AUTH.did
          .launchNewsletters(this.promotionID)
          .then(() => {
            window.PEP.PROFILE_AUTH.did
              .getGuestNewsletters()
              .then((response: any) => {
                window.PEP.PROFILE_AUTH.on('close', () => {
                  this.isSubscribedNewsletter.next(response);
                });
              });
              try {
                localStorage.removeItem('newsletter');
              } catch (err) {
                this._logger.log(err);
              }
          });
      }
    
      public initOneIDStatus(): Promise<void> {
          return window.PEP.PROFILE_AUTH.did
          .getLoggedInStatus()
          .then((res: any) => {
            if (!res) {
              try {
                localStorage.removeItem('subscribed');
              } catch (error) {
                this._logger.log(error);
              }
            }
            this.isLoggedInSubject.next(res);
          })
          .catch((err: any) => {
            window.PEP.PROFILE_AUTH.did.logout();
          });
      }

      public async statusOneID(): Promise<void> {
        window.PEP.PROFILE_AUTH.did.getLoggedInStatus()
        .then((status: any) => {
            if (!status) {
                return window.PEP.PROFILE_AUTH.launchLogin()
                      .fail((err: any) => {
                        this._logger.log('login modal err: ', err);
                      });
            } 
          
            return window.PEP.PROFILE_AUTH.did.getGuestNewsletters().then((data: any) => {
              this.isSubscribedNewsletter.next(data);
            });
        });
      }

      public setCookiesOneID() {
        return window.PEP.PROFILE_AUTH.on('session-init', (guest: any) => {
          this._logger.log(guest.profile.firstName + ' is logged in');
        });
      }

      public logout() {
          window.PEP.PROFILE_AUTH.on("logout", () => {
            localStorage.removeItem('newsletter');
            localStorage.removeItem('subscribed');
            window.location.reload();
          });
          window.PEP.PROFILE_AUTH.logout();
      }
    
      ngOnDestroy() {
          window.PEP.PROFILE_AUTH.on("session-destroy", () => {
            localStorage.removeItem('newsletter');
            this.logout();
          });
      }
}
